import React from "react"

export default function FormStep({
  formElements,
  formStepsCount,
  activeStep,
  previousStepLabel,
  nextStepLabel,
  renderFormElement,
  validateStep,
  goBack,
}) {
  return (
    <>
      {formElements && formElements.map((formElement, index) => renderFormElement(formElement, formElement.name))}
      {activeStep != 0 && activeStep + 1 != formStepsCount ? (
        <button type="button" className={`button button--medium button--general button--reset Form__Element displaymode-half`} onClick={goBack}>
          {previousStepLabel || "Tilbage"}
        </button>
      ) : null}
      {activeStep + 1 != formStepsCount ? (
        <button
          type="button"
          className={`button button--medium button--general Form__Element ${activeStep == 0 ? "displaymode-full" : "displaymode-half"}`}
          onClick={validateStep}
        >
          {nextStepLabel || "Næste"}
        </button>
      ) : null}
    </>
  )
}
